$(document).on('click', '.trending-search p', function () {
  const text = $(this).text().trim();
  const $input = $('#side-panel-search-input');
  $input
    .val(text)
    .focus()
    .trigger('input'); 
});

const observer = new MutationObserver(() => {
  const srLink = document.querySelector('a.acsb-sr-only');
  if (srLink) {
    const target = document.querySelector('header') || document.querySelector('[role="banner"]');
    if (target) {
      target.prepend(srLink);
      observer.disconnect(); 
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });


// PDP — Scroll To Product Section

    const productSection = document.querySelector('.shopify-section.product-section');
    if (productSection) {
      requestAnimationFrame(() => {
        const yOffset = -60; 
        const element = productSection;
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    }




function formatPrice(price) {
  return price.toFixed(2);
}

function updatePrices(variant) {
  if (!variant || !variant.price) return;
  
  var price = variant.price / 100;
  
  var monthlyEl = document.querySelector('.monthly-price');
  var installmentEl = document.querySelector('.installment-price');
  
  if (monthlyEl) {
    monthlyEl.textContent = '$' + formatPrice(price / 12);
  }
  if (installmentEl) {
    installmentEl.textContent = '$' + formatPrice(price / 4);
  }
  
  console.log('Prices updated:', {
    price: price,
    monthly: price / 12,
    installment: price / 4
  });
}

document.addEventListener('DOMContentLoaded', function() {
  console.log('Payment messaging initializing...');
  
  var container = document.querySelector('.payment-messaging-wrap');
  if (container && container.dataset.price) {
    var price = parseFloat(container.dataset.price);
    if (!isNaN(price) && price > 0) {
      var variant = { price: price * 100 };
      updatePrices(variant);
      console.log('Price initialized from container:', price);
      return;
    }
  }
  
  var select = document.querySelector('[name="id"]');
  if (select) {
    var selectedOption = select.options[select.selectedIndex];
    if (selectedOption) {
      var price = parseFloat(selectedOption.dataset.price);
      if (!isNaN(price) && price > 0) {
        var variant = { price: price };
        updatePrices(variant);
        console.log('Price initialized from select data:', price);
        return;
      }
      
      var priceMatch = selectedOption.textContent.match(/\$?([\d,]+\.?\d*)/);
      if (priceMatch) {
        price = parseFloat(priceMatch[1].replace(/,/g, ''));
        if (!isNaN(price) && price > 0) {
          var variant = { price: price * 100 };
          updatePrices(variant);
          console.log('Price initialized from select text:', price);
          return;
        }
      }
    }
  }
  
  if (window.product && window.product.variants) {
    var availableVariant = window.product.variants.find(function(v) { 
      return v.available; 
    });
    if (availableVariant && availableVariant.price > 0) {
      updatePrices(availableVariant);
      console.log('Price initialized from product data:', availableVariant.price / 100);
      return;
    }
  }
  
  console.log('Could not find price on page load');
});

document.addEventListener("product:variant-change", function (evt) {
  console.log("Variant changed:", evt.detail.variant);
  if (evt.detail.variant) {
    updatePrices(evt.detail.variant);
  }
});

document.addEventListener('variant:change', function(e) {
  if (e.detail && e.detail.variant) {
    updatePrices(e.detail.variant);
  }
});

document.addEventListener('change', function(e) {
  if (e.target.matches('[name="id"]')) {
    setTimeout(function() {
      var select = e.target;
      var selectedOption = select.options[select.selectedIndex];
      
      var price = parseFloat(selectedOption.dataset.price);
      if (!isNaN(price) && price > 0) {
        var variant = { price: price };
        updatePrices(variant);
        return;
      }
      
      var priceMatch = selectedOption.textContent.match(/\$?([\d,]+\.?\d*)/);
      if (priceMatch) {
        price = parseFloat(priceMatch[1].replace(/,/g, ''));
        if (!isNaN(price) && price > 0) {
          var variant = { price: price * 100 };
          updatePrices(variant);
        }
      }
    }, 100);
  }
});